import { useMemo } from 'react';
import { ListItemButton } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { queueModal } from '@components/Modals/modalSlice';
import { useAppDispatch } from '@reduxStore';

/**
 * Multi Container Update
 */
export default function MultiContainerUpdate() {
	const gridApiRef = useGridApiContext();
	const appDispatch = useAppDispatch();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	const legs = useMemo(() => {
		return Array.from(selectedRowIds.entries()).map(([, row]) => row as DispatchLeg);
	}, [selectedRowIds]);

	// This action requires 1 or more rows to be selected
	if (selectedRowIds.size === 0) {
		return <></>;
	}

	const handleBtnClick = () => {
		appDispatch(
			queueModal({
				Component: 'multiContainerUpdate',
				Props: {
					legs: legs
				}
			})
		);
	};

	return <ListItemButton onClick={handleBtnClick}>Update Customer Ref</ListItemButton>;
}
